export const existingUnits: Array<IOption> = [
  {value: 'ton', label: 'تن'},
  {value: 'gram', label: 'گرم'},
  {value: 'kilogram', label: 'کیلوگرم'},
  {value: 'liter', label: 'لیتر'},
];
